export default {
  pageTitle: "香港华浩国际 - 汇聚全球精选，服务本土商业",
  nav: {
    home: "首页",
    business: "经营范围",
    advantages: "核心优势",
    about: "关于我们",
  },
  palette: {
    title: "网站调色板",
    presetThemes: "预设主题",
    customColors: "自定义颜色",
    headerColorStart: "顶部导航栏起始颜色",
    headerColorEnd: "顶部导航栏结束颜色",
    gradientStart: "背景渐变起始色",
    gradientEnd: "背景渐变结束色",
    iconGradientStart: "Icon渐变起始色",
    iconGradientEnd: "Icon渐变结束色",
    accent: "强调色",
    accentLight: "浅色强调色",
    preview: "颜色预览",
    save: "保存配置",
    export: "导出配置",
    reset: "恢复默认",
    saveSuccess: "配色方案已保存！",
    exportSuccess: "配置已导出！",
    resetConfirm: "确定要恢复默认配色方案吗？",
    resetSuccess: "已恢复默认配色！",
    warning: "警告",
    confirm: "确定",
    cancel: "取消",
    sectionTitleColor: "章节字体颜色",
  },

  hero: {
    slide1: {
      title: "汇聚全球精选 服务本土商业",
      subtitle: "华浩国际，您全方位的产品与供应链伙伴。致力于连接全球优质资源，为各行各业提供从基础原料到智能科技的多元化商品解决方案",
      button: "联系我们",
    },
    slide2: {
      title: "安全快捷 准确专业",
      subtitle: "将全球视野与本地化服务深度融合，成为客户最值得信赖的产品库和解决方案伙伴",
      button: "了解更多",
    },
    slide3: {
      title: "跨领域 · 综合性贸易企业",
      subtitle: "从传统制造到尖端科技，一站式满足您多样化的采购需求",
      button: "立即咨询",
    },
  },
  business: {
    title: "经营范围",
    subtitle: "全面覆盖多个行业，满足多元化市场需求",
    items: [
      {
        icon: "fas fa-microchip",
        title: "科技与创新领域",
        description: "站在技术革新的前沿，我们整合人工智能、软件开发、智能硬件与集成电路等资源，用科技驱动您的业务未来。",
        items: ["人工智能软件", "智能机器人", "集成电路", "电子元器件", "技术开发与服务"],
      },
    ],
  },
  advantages: {
    title: "核心优势",
    subtitle: "专业、可靠、值得信赖的全球贸易伙伴",
    items: [
      {
        title: "多元化产品矩阵",
        description: "从日常消费到工业支撑，从传统制造到尖端科技，提供跨行业的丰富产品选择。一站式满足您多样化的采购需求，简化供应商管理。",
        icon: "fas fa-boxes",
        features: ["跨行业产品选择", "一站式采购服务", "简化供应商管理"],
      },
      {
        title: "深度全球采购网络",
        description: "与世界各地众多优质工厂及品牌建立稳固的直接合作关系。从源头把控产品质量与成本，为您带来最具竞争力的价格。",
        icon: "fas fa-globe-americas",
        features: ["全球工厂直接合作", "源头品质成本把控", "最具竞争力价格"],
      },
      {
        title: "专业选品与品控",
        description: "团队具备专业的市场知识，提供选品建议和市场洞察。严格的品质控制流程贯穿始终，确保交付的每一件商品都符合预期标准。",
        icon: "fas fa-certificate",
        features: ["专业市场知识与洞察", "严格品控流程", "确保产品标准"],
      },
      {
        title: "敏捷定制化服务",
        description: "理解标准方案并非万能。无论是特殊规格、小批量试单还是联合品牌开发，都能提供灵活、响应的服务，量身打造最合适的贸易解决方案。",
        icon: "fas fa-cogs",
        features: ["特殊规格定制", "小批量试单支持", "量身定制方案"],
      },
    ],
  },
  about: {
    title: "关于我们",
    subtitle: "深耕全球贸易，打造一站式产品与供应链解决方案",
    companyProfile: "企业简介",
    description1: '华浩国际（香港）有限公司是一家跨领域的综合性贸易企业，秉承"全球资源，本土服务"的理念，专注于为客户提供从基础原料到尖端科技的全方位产品解决方案。',
    description2: "在华浩，贸易不仅仅是商品的买卖，更是信任的传递和价值的创造。我们致力于通过严谨的品质把控、专业的市场分析及灵活的定制服务，为每一位客户创造长期而稳定的价值，助力您的业务持续增长。",
    stats: [
      { number: "10+", label: "年行业经验" },
      { number: "20+", label: "业务领域" },
      { number: "500+", label: "合作客户" },
      { number: "100%", label: "客户满意度" },
    ],
  },

  // 公司信息详情页
  companyInfo: {
    headerTag: "ABOUT US",
    title: "关于我们",
    subtitle: "连接世界 · 成就未来 · 共创价值",
    stats: [
      { key: "years", icon: "el-icon-trophy", suffix: "+", label: "年行业经验", target: 15 },
      { key: "countries", icon: "el-icon-map-location", suffix: "+", label: "国家覆盖", target: 68 },
      { key: "partners", icon: "el-icon-user", suffix: "+", label: "合作伙伴", target: 500 },
      { key: "volume", icon: "el-icon-data-line", suffix: "亿", label: "年交易额", target: 2.8 },
    ],
    intro: {
      title: "专业的国际贸易服务商",
      paragraphs: ["成立于2010年，我们专注于为全球客户提供专业、高效的国际贸易解决方案。经过15年的深耕细作，已成长为行业内极具影响力的综合性贸易服务企业。", "业务遍及全球68个国家和地区，与500多家优质供应商建立长期战略合作关系，年交易额突破2.8亿美元。", "我们致力于为客户创造最大价值，通过整合全球资源、优化供应链、提供金融支持等方式，助力企业在国际市场中取得成功。"],
      features: ["专业团队", "全球网络", "品质保证"],
    },
    timeline: {
      title: "携手共进的十五年",
      items: [
        { year: "2010", title: "扬帆起航", desc: "公司在上海成立，专注国际贸易服务" },
        { year: "2013", title: "拓展版图", desc: "业务扩展至东南亚及欧洲市场" },
        { year: "2016", title: "数字赋能", desc: "引入智能供应链管理系统" },
        { year: "2020", title: "全球布局", desc: "业务覆盖全球68个国家和地区" },
        { year: "2025", title: "智慧未来", desc: "打造AI驱动的智慧贸易平台" },
      ],
    },
    services: {
      title: "一站式国际贸易服务",
      items: [
        { icon: "el-icon-shopping-cart-2", title: "全球采购", desc: "整合全球优质供应商，提供一站式采购服务" },
        { icon: "el-icon-connection", title: "供应链管理", desc: "端到端供应链解决方案，全程可视化管理" },
        { icon: "el-icon-truck", title: "国际物流", desc: "海陆空多式联运，确保货物安全准时到达" },
        { icon: "el-icon-wallet", title: "贸易融资", desc: "灵活的融资方案，助力企业资金周转" },
        { icon: "el-icon-data-analysis", title: "市场分析", desc: "深度市场研究，把握商业机会" },
        { icon: "el-icon-document", title: "商务咨询", desc: "专业贸易咨询，规避风险合规经营" },
      ],
    },
    values: {
      title: "我们的承诺",
      intro: "秉承专业、诚信、创新的理念，为客户提供卓越的服务体验",
      items: [
        { title: "诚信为本", desc: "以诚信赢得信任，建立长期合作关系" },
        { title: "专业高效", desc: "专业团队提供高效服务，创造最大价值" },
        { title: "持续创新", desc: "不断创新服务模式，引领行业发展" },
        { title: "合作共赢", desc: "与伙伴共同成长，实现互利共赢" },
      ],
    },
    cta: {
      title: "开启全球贸易新篇章",
      subtitle: "期待与您携手合作，共创辉煌未来",
      button: "联系我们",
    },
  },
  partners: {
    title: "合作伙伴",
    subtitle: "我们与全球知名企业建立了长期稳定的合作关系，共同为客户提供优质的产品和服务",
  },
  strategy: {
    title: "发展战略",
    subtitle: "",
    description: "面向未来发展，以客户为中心，不断创新商业模式。致力于打造全球化产业平台，深化与世界各地的合作。通过数字化转型，提升供应链效率和服务质量，为客户创造更大价值，实现可持续发展。",
  },
  footer: {
    contact: "联系方式",
    quickLinks: "快速链接",
    company: "公司",
    companyName: "华浩国际（香港）有限公司",
    slogan1: "创新引领，科技赋能",
    slogan2: "品质生活，普惠全球",
    motto: "Empower global customers with innovation and technology",
    address: "1325 13/F Golden Industrial Bldg, Kwai Fong, NT, Hong Kong",
    phone: "+852 53031585(HK)",
    email: "+852 3709 7014",
    copyright: "© Copyright 2025. Shanghai Kuji Trading Co., Ltd. | 沪ICP备XXXXXXXX号-X",
    icp: "ICP备案号",
  },
  messages: {
    contactSuccess: "感谢您的关注，我们将尽快与您联系！",
    learnMore: "感谢您的关注！",
    inquireNow: "感谢您的咨询，我们的工作人员会尽快与您取得联系！",
  },

  // 人工智能软件页面
  aiSoftware: {
    pageTitle: "人工智能软件",
    pageIntro: "基于前沿人工智能技术，提供覆盖视觉、语音、算法、应用的全栈AI软件解决方案",
    categories: [
      {
        title: "视觉AI",
        items: [
          { name: "计算机视觉", desc: "高精度图像识别与场景理解" },
          { name: "人脸识别", desc: "毫秒级人脸检测与身份验证" },
          { name: "OCR文字识别", desc: "支持多语言的智能文字提取" },
        ],
      },
      {
        title: "语音AI",
        items: [
          { name: "语音识别", desc: "实时语音转文字，支持多种方言" },
          { name: "语音合成", desc: "自然流畅的TTS语音输出" },
          { name: "智能语音助手", desc: "多轮对话与智能语音交互" },
        ],
      },
      {
        title: "算法平台",
        items: [
          { name: "机器学习平台", desc: "一站式模型训练与部署平台" },
          { name: "深度学习框架", desc: "高性能神经网络计算引擎" },
          { name: "AI算法服务", desc: "开箱即用的算法API服务" },
        ],
      },
      {
        title: "智能应用",
        items: [
          { name: "智能推荐系统", desc: "精准的个性化内容推荐引擎" },
          { name: "自然语言处理", desc: "文本分析与智能语义理解" },
          { name: "智能客服系统", desc: "7x24小时AI客服解决方案" },
        ],
      },
    ],
  },

  // 智能机器人页面
  smartRobot: {
    pageTitle: "智能机器人",
    pageIntro: "华浩国际深耕智能机器人领域，凭借先进的AI算法、精密传感技术和智能控制系统，为客户提供覆盖服务、教育、家庭清洁等多场景的机器人产品解决方案，以创新科技赋能智慧生活，为消费者打造更便捷、更智能的未来生活方式。",
    sections: [
      {
        title: "服务机器人",
        paragraphs: ["结合先进的人工智能技术、计算机视觉、自然语言处理和自主导航系统，为客户提供智能交互、精准识别、灵活移动的服务机器人整体解决方案。产品广泛应用于商业接待、医疗辅助、酒店服务等多个场景。", "通过深度学习算法和多传感器融合技术，实现人机自然交互、环境感知与避障、任务自主执行等核心功能，为各行业提供高效、可靠的智能服务体验。"],
      },
      {
        title: "教育机器人",
        paragraphs: ["专注于STEAM教育和编程教学领域，融合机器人技术、编程教育和人工智能，为青少年提供寓教于乐的智能教育产品。支持图形化编程、Python编程等多种编程方式，培养学生的创新思维和动手能力。", "配备丰富的传感器模块和执行器件，支持项目式学习和竞赛活动，帮助学生在实践中掌握机器人技术、编程逻辑和AI应用，激发对科技的兴趣和探索精神。"],
      },
      {
        title: "扫地机器人",
        paragraphs: ["采用激光雷达SLAM技术和视觉导航系统，实现精准建图、智能规划清扫路径和高效清洁覆盖。结合强劲吸力、智能湿拖系统和自动集尘功能，为用户提供全方位的家庭清洁解决方案。", "通过AI算法实现障碍物识别与智能避障，支持多楼层地图管理、定时预约、远程控制等智能功能。低噪音设计和长续航能力，让家庭清洁更加轻松便捷，释放用户更多时间享受生活。"],
      },
    ],
  },

  // 技术开发与服务页面
  techService: {
    pageTitle: "技术开发与服务",
    pageIntro: "提供企业级软件系统解决方案，助力企业数字化转型与业务增长",
    systems: [
      {
        title: "CRM系统",
        subtitle: "Customer Relationship Management",
        features: ["客户全生命周期管理", "销售漏斗可视化分析", "智能商机跟进提醒", "多渠道客户数据整合", "自动化营销工作流", "数据报表与决策支持"],
      },
      {
        title: "SCRM系统",
        subtitle: "Social Customer Relationship Management",
        features: ["社交媒体客户管理", "企业微信深度集成", "私域流量运营工具", "社群自动化管理", "客户标签精准画像", "社交互动数据分析"],
      },
      {
        title: "SAAS系统",
        subtitle: "Software as a Service",
        features: ["云端部署开箱即用", "多租户架构设计", "弹性扩展按需付费", "数据安全与备份", "跨平台无缝协作", "持续更新与维护"],
      },
    ],
  },

  // 智能穿戴页面
  smartWearable: {
    pageTitle: "智能穿戴",
    pageIntro: "华浩以敏锐的市场洞察力,率先切入运动健康领域。分析产业、行业趋势，在智能手表、智能手环、TWS耳机等产品上不断超越，运用卓越的技术创新、精密制造能力为客户提供超出预期的整体解决方案，为消费者打造更为丰富的数字化健康生活方式。",
    sections: [
      {
        title: "智能手表",
        paragraphs: ["具有行业领先的全领域软件开发能力，多种业界主流运动手表、通话手表的系统开发和全平台复杂架构设计经验，拥有位居行业前列的器件高密度布局技术，极致利用产品空间，成熟的5ATM防水设计/测试贯穿生产全阶段。", "产品全球化定制，柔性制造交付能力，充分满足客户需求。"],
      },
      {
        title: "智能手环",
        paragraphs: ["在多重功耗优化、运动健康设计开发与算法调试、多平台研发上具有丰富的经验和技术。", "通过长续航、低功耗设计、小型化设计、防水油设计、天线方案系统设计，柔性制造交付能力，有效满足客户的多样化需求。"],
      },
      {
        title: "TWS耳机",
        paragraphs: ["拥有行业领先的声学设计、调试、测试及音频算法能力，采用智能降噪、高清音频传输等先进技术，即使在嘈杂环境下，仍可带来高品质的音乐享受、呈现纯粹的高保真音质。", "结合天线、低功耗、防水等丰富的整机设计经验，主流Android客户的服务经验，为客户提供从入门级到旗舰级的声学整体解决方案。"],
      },
    ],
  },

  // 家庭终端页面
  homeTerminal: {
    pageTitle: "家庭终端",
    pageIntro: "为家庭终端产品提供从市场调研、产品概念、ID设计到研发、生产制造的一体化解决方案，在VR & AR、智能音箱、智能门锁、TV等产品领域，为客户提供高品质、高性价比的整体解决方案，为消费者打造更轻松、更有温度的沉浸式超凡体验。",
    sections: [
      {
        title: "VR & AR",
        paragraphs: ["凭借自身强大的集成软硬件设计与精密制造能力，为客户提供VR&AR一站式系统解决方案，涵盖光学、声学、功耗、射频、天线、堆叠、结构、软件底层驱动、6DoF算法、眼动算法、面部识别算法等在内的整体设计方案，以及零部件、模具、注塑、校准、组装、自动化在内的整体制造方案。", "为消费者完美呈现4K 360°影像，带来更舒适、更具沉浸式的超凡体验。"],
      },
      {
        title: "智能音箱",
        paragraphs: ["成熟的触控和高清大屏显示技术，多麦克阵列设计和降噪技术，高功率大喇叭及腔体一体化设计技术为智能音箱研发和生产提供有效保障。", "多硬件平台和安卓系统的开发经验也进一步加速产品的开发和交付，加持专业的音频实验室和主客观评价方法和能力，有效满足客户的高品质要求和体验。"],
      },
      {
        title: "智能门锁",
        paragraphs: ["凭借多年来在指纹、摄像头、触控、屏幕、WIFI及蓝牙方面的技术积累、安全和暴力防拆技术、自身强大的工业设计能力以及对锁芯和锁体的行业整合力，快速在智能门锁领域脱颖而出。", "产品覆盖各价位段，充分满足客户的多样化需求。"],
      },
      {
        title: "TV",
        paragraphs: ["主要从事板卡、电视棒等产品的研发、生产和交付，通过不断提供革新性的产品及服务，目前已覆盖TV、Monitor、商用显示整机等，根据客户的需求进行客制化产品的开发设计。", "帮助客户以更优的成本、更快的速度和更高的品质为用户提供更优质的产品及服务。"],
      },
    ],
  },

  // 个人终端页面
  personalTerminal: {
    pageTitle: "个人终端",
    pageIntro: "从产品定制到平台能力，华浩国际持续深耕个人终端领域，构建覆盖多终端形态的智能产品体系，为全球客户提供从研发到量产的一站式解决方案。",
    sections: [
      {
        title: "智能手机 & 平板电脑",
        paragraphs: ["作为个人终端领域的重要组成部分，华浩在智能手机与平板电脑方向持续推进技术创新与制造能力升级，建立了灵活高效的多区域交付体系。", "围绕不同客户的产品定位与市场需求，华浩深入分析终端用户使用习惯、主流市场趋势及新技术演进方向，结合性能、成本与可靠性的综合考量，为客户打造具备竞争力的高品质终端产品。"],
      },
      {
        title: "笔记本电脑",
        paragraphs: ["凭借持续的技术投入与智能制造能力建设，华浩在笔记本电脑领域逐步形成了成熟的产品开发与交付体系。", "围绕轻薄化、高性能与可靠性的核心需求，华浩不断突破在结构设计、散热方案与整机集成方面的技术边界，与客户协同打造兼顾性能与品质的笔记本电脑产品。"],
      },
    ],
  },

  // 在 zh.js 中添加 contact 部分
  contact: {
    pageTitle: "联系我们",
    breadcrumb: {
      home: "首页",
      contact: "联系我们",
    },
    form: {
      title: "联系我们",
      description: "如有任何问题、商业咨询或合作机会，请随时与我们联系。我们将以专业的态度尽快为您提供帮助。",
      hongKongOffice: "香港办公室",
      officeLine: "办公电话",
      tel: "电话",
      email: "邮箱",
      coordinates: "坐标",
      latLng: "(纬度, 经度)",
    },
    map: {
      baidu: "百度地图",
      amap: "高德地图",
      google: "Google Maps",
      copyCoordinates: "复制坐标",
      copySuccess: "坐标已复制到剪贴板:",
      copyFailed: "复制失败，请手动复制:",
      copyError: "复制失败，坐标为:",
    },
  },
};
